import Vue from 'vue'

const indexBy = 'uuid'

const mutations = {
  SET (state, brands = []) {
    state.brands = {}
    brands.forEach(brand => {
      Vue.set(state.brands, brand[indexBy], brand)
    })
  },

  ADD (state, brand) {
    Vue.set(state.brands, brand[indexBy], brand)
  },

  REMOVE (state, key) {
    Vue.delete(state.brands, key)
    if (state.active === key) {
      state.active = null
    }
  },

  SET_ACTIVE (state, key = null) {
    state.active = state.brands[key]
  },

  UPDATE (state, brand) {
    state.brands[brand[indexBy]] = {
      ...state.brands[brand[indexBy]],
      ...brand
    }
  },

  UPDATE_NEW ({ newBrand }, { key, value }) {
    Vue.set(newBrand, key, value)
  },

  CLEAR_NEW ({ newBrand }) {
    Object.keys(newBrand).forEach(key => {
      newBrand[key] = ''
    })
  }
}

export default mutations
